import React from "react";
import {Form} from 'react-bootstrap';


function STCFormCheckInput(props){

    return(
        <Form.Check.Input
            style={props.style}
            className={props.className}

            as={props.as}
            id={props.id}
            isInvalid={props.isInvalid}
            isValid={props.isValid}
            type={props.type}
            bsPrefix={props.type}
        >
            {props.children}
        </Form.Check.Input>
    )
}
export default STCFormCheckInput;

